import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import {cabecalhoSelector, fetchBeneficiariosSocio, fetchCBEs, fetchCCEs, fetchDEFs, fetchRDEIEDs, fetchRepresentantes, fetchSocio, fetchSocios, socioSelector} from '../../../../store/empresa';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaSocioForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaSocioEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const cabecalho = useSelector(cabecalhoSelector);
  const socio = useSelector(socioSelector);
  const loading = useLoading(fetchSocio.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(socio);
    setImmediate(() => document.querySelector('#documento').focus());
  }, [socio]);

  const handleFinish = values => {
    setLoadingSave(true);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/socios/${id}`, values), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/socios/${id}`);
          dispatch(fetchSocios({empresaId}));
          dispatch(fetchRepresentantes({empresaId}));
          dispatch(fetchBeneficiariosSocio({empresaId}));
          dispatch(fetchRDEIEDs({empresaId}));
          dispatch(fetchDEFs({empresaId}));
          dispatch(fetchCCEs({empresaId}));
          dispatch(fetchCBEs({empresaId}));
          dispatch(fetchSocio({empresaId, id}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/socios/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaSocioForm
          disabled={loadingSave}
          cabecalho={cabecalho}
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
